import React, { Component } from 'react'
import Slider from 'react-rangeslider'

// To include the default styles
import 'react-rangeslider/lib/index.css'
//https://github.com/whoisandy/react-rangeslider

export default class DiscretizedSlider extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      v_value: 0,
      answer: 0
    }
  }

  componentDidMount(){
    this.interval = setInterval(() => this.tick(), 1000);
}

componentWillUnmount() {
  clearInterval(this.interval);
}

  tick(){
    //this.setState({
    //  answer: this.state.v_value
    //})
    this.props.stateUpdatingCallback();
  }

  handleOnChange = (value) => {
    this.setState({
      v_value: value,
      answer: value
    })
  }

  handleOnChangeComplete = () => {
    this.props.OnChange()
  }

  render() {
    let { v_value } = this.state

    if(this.state.whatever !== undefined && this.state.whatever2 === undefined){
      this.props.stateUpdatingCallback();
      this.setState({whatever2: "yeah!"});
    }
    if(this.state.whatever === undefined )
      this.setState({whatever: "yeah!"});

    return (
      <Slider
        tooltip={false}
        value={v_value}
        step={100.0/(Object.keys(this.props.labels).length-1)}
        labels = {this.props.labels}
        onChange={this.handleOnChange}
        onChangeComplete={this.handleOnChangeComplete}
      />
    );
  }
}